import { v4 as uuidv4 } from "uuid";
import {
  names,
  companies,
  check_types,
  behavior_kits,
  randomChoice,
} from "./sampleData";
import { buildMockPromise } from "../api/helpers";
import {
  ThreeSixtyAmendmentRow,
  ThreeSixtyFinishedRow,
  ThreeSixtyInvestigatingRow,
  ThreeSixtyQARow,
  ThreeSixtyQueueingRow,
  ThreeSixtyWebSearchRow,
} from "../api/ThreeSixty";
import { WorkflowRun } from "../api/Workflows";

export async function getThreeSixtyQueueingListMock(): Promise<
  ThreeSixtyQueueingRow[]
> {
  const misconduct_steps: string[] = [
    "Doing Stuff",
    "Doing Things",
    "Whatever",
  ];
  const past_dates: string[] = [];
  const future_dates: string[] = [];
  for (let i = 0; i < 5; i++) {
    const past = new Date(),
      future = new Date();
    past.setDate(past.getDate() - i);
    past_dates.push(past.toISOString());
    future.setDate(future.getDate() + i);
    future_dates.push(future.toISOString());
  }
  const output: ThreeSixtyQueueingRow[] = [];
  for (let a = 0; a < 63; a++) {
    const temp: ThreeSixtyQueueingRow = {
      candidate_name: randomChoice(names),
      workflow_run_uuid: uuidv4(),
      request_uuid: uuidv4(),
      company_uuid: uuidv4(),
      company_name: randomChoice(companies),
      check_type_uuid: uuidv4(),
      check_type_name: randomChoice(check_types),
      behavior_kit_uuid: uuidv4(),
      behavior_kit_name: randomChoice(behavior_kits),
      misconduct_step: randomChoice(misconduct_steps),
      requested_at: randomChoice(past_dates),
      due_date: randomChoice(future_dates),
      due_date_updated: randomChoice([false, false, false, true]),
      custom_id: `CID_${Math.floor(Math.random() * 10000)}`,
    };
    output.push(temp);
  }
  return await buildMockPromise<ThreeSixtyQueueingRow[]>(output);
}

export async function getThreeSixtyWebSearchListMock(): Promise<
  ThreeSixtyWebSearchRow[]
> {
  const past_dates: string[] = [];
  const future_dates: string[] = [];
  for (let i = 0; i < 5; i++) {
    const past = new Date(),
      future = new Date();
    past.setDate(past.getDate() - i);
    past_dates.push(past.toISOString());
    future.setDate(future.getDate() + i);
    future_dates.push(future.toISOString());
  }
  const output: ThreeSixtyInvestigatingRow[] = [];
  for (let a = 0; a < 51; a++) {
    const temp: ThreeSixtyInvestigatingRow = {
      candidate_name: randomChoice(names),
      workflow_run_uuid: uuidv4(),
      request_uuid: uuidv4(),
      company_uuid: uuidv4(),
      company_name: randomChoice(companies),
      check_type_uuid: uuidv4(),
      check_type_name: randomChoice(check_types),
      behavior_kit_uuid: uuidv4(),
      behavior_kit_name: randomChoice(behavior_kits),
      requested_at: randomChoice(past_dates),
      due_date: randomChoice(future_dates),
      due_date_updated: randomChoice([false, false, false, true]),
      locked_by: randomChoice(names.slice(0, 5)),
      custom_id: `CID_${Math.floor(Math.random() * 10000)}`,
    };
    output.push(temp);
  }
  return await buildMockPromise<ThreeSixtyInvestigatingRow[]>(output);
}

export async function getThreeSixtyInvestigatingListMock(): Promise<
  ThreeSixtyInvestigatingRow[]
> {
  const past_dates: string[] = [];
  const future_dates: string[] = [];
  for (let i = 0; i < 5; i++) {
    const past = new Date(),
      future = new Date();
    past.setDate(past.getDate() - i);
    past_dates.push(past.toISOString());
    future.setDate(future.getDate() + i);
    future_dates.push(future.toISOString());
  }
  const output: ThreeSixtyInvestigatingRow[] = [];
  for (let a = 0; a < 51; a++) {
    const temp: ThreeSixtyInvestigatingRow = {
      candidate_name: randomChoice(names),
      workflow_run_uuid: uuidv4(),
      request_uuid: uuidv4(),
      company_uuid: uuidv4(),
      company_name: randomChoice(companies),
      check_type_uuid: uuidv4(),
      check_type_name: randomChoice(check_types),
      behavior_kit_uuid: uuidv4(),
      behavior_kit_name: randomChoice(behavior_kits),
      requested_at: randomChoice(past_dates),
      due_date: randomChoice(future_dates),
      due_date_updated: randomChoice([false, false, false, true]),
      locked_by: randomChoice(names.slice(0, 5)),
      custom_id: `CID_${Math.floor(Math.random() * 10000)}`,
    };
    output.push(temp);
  }
  return await buildMockPromise<ThreeSixtyInvestigatingRow[]>(output);
}

export async function getThreeSixtyQAListMock(): Promise<ThreeSixtyQARow[]> {
  const past_dates: string[] = [];
  const future_dates: string[] = [];
  for (let i = 0; i < 5; i++) {
    const past = new Date(),
      future = new Date();
    past.setDate(past.getDate() - i);
    past_dates.push(past.toISOString());
    future.setDate(future.getDate() + i);
    future_dates.push(future.toISOString());
  }
  const output: ThreeSixtyQARow[] = [];
  for (let a = 0; a < 51; a++) {
    const temp: ThreeSixtyQARow = {
      candidate_name: randomChoice(names),
      workflow_run_uuid: uuidv4(),
      request_uuid: uuidv4(),
      company_uuid: uuidv4(),
      company_name: randomChoice(companies),
      check_type_uuid: uuidv4(),
      check_type_name: randomChoice(check_types),
      behavior_kit_uuid: uuidv4(),
      behavior_kit_name: randomChoice(behavior_kits),
      requested_at: randomChoice(past_dates),
      due_date: randomChoice(future_dates),
      due_date_updated: randomChoice([false, false, false, true]),
      custom_id: `CID_${Math.floor(Math.random() * 10000)}`,
      locked_by: randomChoice(names.slice(0, 5)),
    };
    output.push(temp);
  }
  return await buildMockPromise<ThreeSixtyQARow[]>(output);
}

export async function getThreeSixtyFinishedListMock(): Promise<
  [number, ThreeSixtyFinishedRow[]]
> {
  const rows: ThreeSixtyFinishedRow[] = [
    {
      request_uuid: "b203c9f3-2c31-40f0-aa68-1444f8c5b8ab",
      name: "test threesixt",
      custom_id: "6",
      due_date: "2025-12-08T22:00:00+00:00",
      finished_at: "2025-12-08T22:00:00+00:00",
      company_uuid: "5d01a633-d0d2-4bb8-8f0b-f5750e0ae476",
      company_name: "Carlos Inc.",
      blueprint_uuid: "9ad20484-fd65-4416-b02a-0315bc60bf2c",
      blueprint_name: "360 - News, Fama Report, Summary",
      behavior_kit_uuid: null,
      behavior_kit_name: null,
      insights: {
        total: 10,
        posts: 8,
        articles: 2,
        news: 1,
        legal: 3,
        keywords: 3,
        community: 1,
        adverse: 8,
      },
    },
    {
      request_uuid: "39684852-e451-46dc-a3e8-0f982f322bb6",
      name: "test threesixt",
      custom_id: "5",
      due_date: "2025-12-08T22:00:00+00:00",
      finished_at: "2025-12-08T21:00:00+00:00",
      company_uuid: "5d01a633-d0d2-4bb8-8f0b-f5750e0ae476",
      company_name: "Carlos Inc.",
      blueprint_uuid: "852cd31a-c939-4874-94cd-19d9f396e342",
      blueprint_name: "360 - Summary Only",
      behavior_kit_uuid: null,
      behavior_kit_name: null,
      insights: {
        total: 10,
        posts: 8,
        articles: 2,
        news: 1,
        legal: 3,
        keywords: 3,
        community: 1,
        adverse: 8,
      },
    },
    {
      request_uuid: "ab2e689b-9870-42cf-96f1-f229b7a06301",
      name: "test threesixt",
      custom_id: "4",
      due_date: "2025-12-08T22:00:00+00:00",
      finished_at: "2025-12-08T23:00:00+00:00",
      company_uuid: "5d01a633-d0d2-4bb8-8f0b-f5750e0ae476",
      company_name: "Carlos Inc.",
      blueprint_uuid: "a52d200f-bc77-4656-b1f9-56bb07418b76",
      blueprint_name: "360-Full",
      behavior_kit_uuid: null,
      behavior_kit_name: null,
      insights: {
        total: 10,
        posts: 8,
        articles: 2,
        news: 1,
        legal: 3,
        keywords: 3,
        community: 1,
        adverse: 8,
      },
    },
    {
      request_uuid: "7350c34d-d4fc-4e63-b852-e51dbbb1b7f1",
      name: "test threesixt",
      custom_id: "2",
      due_date: "2025-12-08T22:00:00+00:00",
      finished_at: null,
      company_uuid: "5d01a633-d0d2-4bb8-8f0b-f5750e0ae476",
      company_name: "Carlos Inc.",
      blueprint_uuid: "2cde67a8-9abe-4cf3-899e-0845775aedf5",
      blueprint_name: "360 - Legal Only",
      behavior_kit_uuid: null,
      behavior_kit_name: null,
      insights: {
        total: 10,
        posts: 8,
        articles: 2,
        news: 1,
        legal: 3,
        keywords: 3,
        community: 1,
        adverse: 8,
      },
    },
    {
      request_uuid: "ebc4a36d-a258-45f5-9db9-5f4068b14137",
      name: "test threesixt",
      custom_id: "1",
      due_date: "2025-12-08T22:00:00+00:00",
      finished_at: null,
      company_uuid: "5d01a633-d0d2-4bb8-8f0b-f5750e0ae476",
      company_name: "Carlos Inc.",
      blueprint_uuid: "fe6f2670-8310-4bc1-96a1-e218c9715534",
      blueprint_name: "360 Summary only",
      behavior_kit_uuid: null,
      behavior_kit_name: null,
      insights: {
        total: 10,
        posts: 8,
        articles: 2,
        news: 1,
        legal: 3,
        keywords: 3,
        community: 1,
        adverse: 8,
      },
    },
    {
      request_uuid: "f5bbb2a7-7225-4b66-94a2-838a1d7184e0",
      name: "Bruce Wayne",
      custom_id: "231234",
      due_date: "2025-12-05T22:00:00+00:00",
      finished_at: null,
      company_uuid: "71fcad26-a4ca-4b7a-bc9e-d799ecc9fa8b",
      company_name: "Grant Company",
      blueprint_uuid: "a52d200f-bc77-4656-b1f9-56bb07418b76",
      blueprint_name: "360-Full",
      behavior_kit_uuid: null,
      behavior_kit_name: null,
      insights: {
        total: 10,
        posts: 8,
        articles: 2,
        news: 1,
        legal: 3,
        keywords: 3,
        community: 1,
        adverse: 8,
      },
    },
    {
      request_uuid: "bd3c6dc3-cd5f-4365-a2e9-ecadd3e9d3f3",
      name: "ismafull really full",
      custom_id: "98652782",
      due_date: "2025-12-04T22:00:00+00:00",
      finished_at: null,
      company_uuid: "71fcad26-a4ca-4b7a-bc9e-d799ecc9fa8b",
      company_name: "Grant Company",
      blueprint_uuid: "a52d200f-bc77-4656-b1f9-56bb07418b76",
      blueprint_name: "360-Full",
      behavior_kit_uuid: null,
      behavior_kit_name: null,
      insights: {
        total: 10,
        posts: 8,
        articles: 2,
        news: 1,
        legal: 3,
        keywords: 3,
        community: 1,
        adverse: 8,
      },
    },
    {
      request_uuid: "95646f29-c957-4646-8c2f-b83ba7faafa6",
      name: "test msicon",
      custom_id: "",
      due_date: "2025-11-28T22:00:00+00:00",
      finished_at: null,
      company_uuid: "f8a238ed-5d26-4c45-b380-dd9da753cfcc",
      company_name: "JM Corp (formerly Jose Company)",
      blueprint_uuid: "a52d200f-bc77-4656-b1f9-56bb07418b76",
      blueprint_name: "360-Full",
      behavior_kit_uuid: null,
      behavior_kit_name: null,
    },
    {
      request_uuid: "52dd7cd4-4e89-4efb-bef9-a5fd280f9787",
      name: "ThreeSixty Four Famatest",
      custom_id: "360 - Bulk Upload",
      due_date: "2025-11-26T22:00:00+00:00",
      finished_at: null,
      company_uuid: "786407ee-cff8-4362-ad8d-dcb57b243f96",
      company_name: "TA Company For Testing",
      blueprint_uuid: "c5fef465-518c-4bd8-9407-f1c2e403a6a6",
      blueprint_name: "Fama 360 V1",
      behavior_kit_uuid: "25d05b10-1a66-404b-b976-59150b7a578d",
      behavior_kit_name: "2 month Keyword",
    },
    {
      request_uuid: "2c773a41-450f-4d76-9d93-52f07ea32506",
      name: "ThreeSixty Thirteen Famatest",
      custom_id: "360 - Bulk Upload",
      due_date: "2025-11-26T22:00:00+00:00",
      finished_at: null,
      company_uuid: "786407ee-cff8-4362-ad8d-dcb57b243f96",
      company_name: "TA Company For Testing",
      blueprint_uuid: "c5fef465-518c-4bd8-9407-f1c2e403a6a6",
      blueprint_name: "Fama 360 V1",
      behavior_kit_uuid: "25d05b10-1a66-404b-b976-59150b7a578d",
      behavior_kit_name: "2 month Keyword",
    },
    {
      request_uuid: "53e81ef9-f42c-4496-b53c-95e4673dee38",
      name: "ThreeSixty Ten Famatest",
      custom_id: "360 - Bulk Upload",
      due_date: "2025-11-26T22:00:00+00:00",
      finished_at: null,
      company_uuid: "786407ee-cff8-4362-ad8d-dcb57b243f96",
      company_name: "TA Company For Testing",
      blueprint_uuid: "c5fef465-518c-4bd8-9407-f1c2e403a6a6",
      blueprint_name: "Fama 360 V1",
      behavior_kit_uuid: "25d05b10-1a66-404b-b976-59150b7a578d",
      behavior_kit_name: "2 month Keyword",
    },
    {
      request_uuid: "6e566d76-0ab7-4a6e-b440-5847824e09ed",
      name: "ThreeSixty sixteen Famatest",
      custom_id: "360 - Bulk Upload",
      due_date: "2025-11-26T22:00:00+00:00",
      finished_at: null,
      company_uuid: "786407ee-cff8-4362-ad8d-dcb57b243f96",
      company_name: "TA Company For Testing",
      blueprint_uuid: "c5fef465-518c-4bd8-9407-f1c2e403a6a6",
      blueprint_name: "Fama 360 V1",
      behavior_kit_uuid: "25d05b10-1a66-404b-b976-59150b7a578d",
      behavior_kit_name: "2 month Keyword",
    },
    {
      request_uuid: "9258023f-b328-452d-b8ab-623d25e1634f",
      name: "ThreeSixty Six Famatest",
      custom_id: "360 - Bulk Upload",
      due_date: "2025-11-26T22:00:00+00:00",
      finished_at: null,
      company_uuid: "786407ee-cff8-4362-ad8d-dcb57b243f96",
      company_name: "TA Company For Testing",
      blueprint_uuid: "c5fef465-518c-4bd8-9407-f1c2e403a6a6",
      blueprint_name: "Fama 360 V1",
      behavior_kit_uuid: "25d05b10-1a66-404b-b976-59150b7a578d",
      behavior_kit_name: "2 month Keyword",
    },
    {
      request_uuid: "451b8580-d3e1-4b1e-87d4-d4580f6a0d1b",
      name: "ThreeSixty Seven Famatest",
      custom_id: "360 - Bulk Upload 1",
      due_date: "2025-11-26T22:00:00+00:00",
      finished_at: null,
      company_uuid: "786407ee-cff8-4362-ad8d-dcb57b243f96",
      company_name: "TA Company For Testing",
      blueprint_uuid: "c5fef465-518c-4bd8-9407-f1c2e403a6a6",
      blueprint_name: "Fama 360 V1",
      behavior_kit_uuid: "25d05b10-1a66-404b-b976-59150b7a578d",
      behavior_kit_name: "2 month Keyword",
    },
    {
      request_uuid: "a8256fec-7393-445c-991b-263bda543bcd",
      name: "ThreeSixty One Famatest",
      custom_id: "360 - Bulk Upload 1",
      due_date: "2025-11-26T22:00:00+00:00",
      finished_at: null,
      company_uuid: "786407ee-cff8-4362-ad8d-dcb57b243f96",
      company_name: "TA Company For Testing",
      blueprint_uuid: "c5fef465-518c-4bd8-9407-f1c2e403a6a6",
      blueprint_name: "Fama 360 V1",
      behavior_kit_uuid: "25d05b10-1a66-404b-b976-59150b7a578d",
      behavior_kit_name: "2 month Keyword",
    },
    {
      request_uuid: "98949473-5181-425e-8603-dc947bc77a4a",
      name: "ThreeSixty nineteen Famatest",
      custom_id: "360 - Bulk Upload",
      due_date: "2025-11-26T22:00:00+00:00",
      finished_at: null,
      company_uuid: "786407ee-cff8-4362-ad8d-dcb57b243f96",
      company_name: "TA Company For Testing",
      blueprint_uuid: "c5fef465-518c-4bd8-9407-f1c2e403a6a6",
      blueprint_name: "Fama 360 V1",
      behavior_kit_uuid: "25d05b10-1a66-404b-b976-59150b7a578d",
      behavior_kit_name: "2 month Keyword",
    },
    {
      request_uuid: "c6407e75-175c-4c5f-bbdb-c32ec42d0b44",
      name: "ThreeSixty Nibe Famatest",
      custom_id: "360 - Bulk Upload",
      due_date: "2025-11-26T22:00:00+00:00",
      finished_at: null,
      company_uuid: "786407ee-cff8-4362-ad8d-dcb57b243f96",
      company_name: "TA Company For Testing",
      blueprint_uuid: "c5fef465-518c-4bd8-9407-f1c2e403a6a6",
      blueprint_name: "Fama 360 V1",
      behavior_kit_uuid: "25d05b10-1a66-404b-b976-59150b7a578d",
      behavior_kit_name: "2 month Keyword",
    },
    {
      request_uuid: "77c49e9d-e6fe-44e7-9310-25e12bd2cb6b",
      name: "ThreeSixty fourteen Famatest",
      custom_id: "360 - Bulk Upload 1",
      due_date: "2025-11-26T22:00:00+00:00",
      finished_at: null,
      company_uuid: "786407ee-cff8-4362-ad8d-dcb57b243f96",
      company_name: "TA Company For Testing",
      blueprint_uuid: "c5fef465-518c-4bd8-9407-f1c2e403a6a6",
      blueprint_name: "Fama 360 V1",
      behavior_kit_uuid: "25d05b10-1a66-404b-b976-59150b7a578d",
      behavior_kit_name: "2 month Keyword",
    },
    {
      request_uuid: "7dd182da-8a57-4e33-80b9-3dec0b081cb9",
      name: "ThreeSixty twotwo Famatest",
      custom_id: "360 - Bulk Upload",
      due_date: "2025-11-26T22:00:00+00:00",
      finished_at: null,
      company_uuid: "786407ee-cff8-4362-ad8d-dcb57b243f96",
      company_name: "TA Company For Testing",
      blueprint_uuid: "c5fef465-518c-4bd8-9407-f1c2e403a6a6",
      blueprint_name: "Fama 360 V1",
      behavior_kit_uuid: "25d05b10-1a66-404b-b976-59150b7a578d",
      behavior_kit_name: "2 month Keyword",
    },
    {
      request_uuid: "10b14856-642b-4d49-8c9e-e1790b6de06f",
      name: "ThreeSixty Five Famatest",
      custom_id: "360 - Bulk Upload",
      due_date: "2025-11-26T22:00:00+00:00",
      finished_at: null,
      company_uuid: "786407ee-cff8-4362-ad8d-dcb57b243f96",
      company_name: "TA Company For Testing",
      blueprint_uuid: "c5fef465-518c-4bd8-9407-f1c2e403a6a6",
      blueprint_name: "Fama 360 V1",
      behavior_kit_uuid: "25d05b10-1a66-404b-b976-59150b7a578d",
      behavior_kit_name: "2 month Keyword",
    },
  ];
  const output: [number, ThreeSixtyFinishedRow[]] = [87, rows];
  return await buildMockPromise<[number, ThreeSixtyFinishedRow[]]>(output);
}

export async function getThreeSixtyDetailMock(): Promise<WorkflowRun> {
  return await buildMockPromise<WorkflowRun>(
    {
      external_id: "03109460-d27c-435b-9983-30d0cc9c6d89",
      modified_by: "4bc97f20-7f2a-4809-83ff-45c9ce4441a1",
      workflow_config_id: 24,
      name: "360",
      payload: {
        QA: [],
        email: "test@fama.io",
        full_name: "Three Sixty New Profiles",
        client_report_id: "",
        rerun_from_parent_uuid: "",
        parent_workflow_run_uuid: "9886bfad-f720-490d-b2a0-e5eef12f1787",
        parent_workflow_step_run_uuid: "1abacaa8-0bc2-43e2-8191-afe1960cafac",
        flags_count: randomChoice([
          {
            total: Math.floor(Math.random() * 20),
            community_count: Math.floor(Math.random() * 5),
            adverse_flag_count: Math.floor(Math.random() * 5),
            posts_count: Math.floor(Math.random() * 5),
            articles_count: Math.floor(Math.random() * 5),
            keywords: Math.floor(Math.random() * 5),
          },
          {},
          {},
        ]),
      },
      status: "DONE",
      reviewed: randomChoice([true, false]),
      due_date: "2025-12-31T22:00:00+00:00",
      due_date_updated: randomChoice([true, false, false]),
      last_running_step: "360QA",
      sla_met: randomChoice([true, true, false]),
    },
    Math.random() * 5000
  );
}

export async function getThreeSixtyAmendmentListMock(): Promise<
  ThreeSixtyAmendmentRow[]
> {
  return await buildMockPromise<ThreeSixtyAmendmentRow[]>([
    {
      request_uuid: "6a02ca15-90ae-4a97-8000-60bdcd0b5272",
      name: "vv pp ss",
      custom_id: "bvbvb",
      due_date: "2026-03-13T00:00:00",
      finished_at: "2026-03-10T14:47:27+00:00",
      company_uuid: "89b88f6f-b6aa-4d67-9e0c-867a05dffd74",
      company_name: "pks subcompany",
      blueprint_uuid: "025c59e0-7d35-4d33-acc3-dd301775f2ff",
      blueprint_name: "Priyanka all items 360",
      behavior_kit_uuid: null,
      behavior_kit_name: null,
      workflow_run_uuid: "6a02ca15-90ae-4a97-8000-60bdcd0b5272",
      locked_by: "test@fama.io",
      amendment_opened_at: "2026-03-13T14:47:27+00:00",
    },
    {
      request_uuid: "8832864a-aa2d-4144-82a5-bdb00d7f60a1",
      name: "TwoDeleteProfile ThreesixtyTest",
      custom_id: "2-11 Use to test deleting profiles",
      due_date: "2026-02-14T01:00:00",
      finished_at: "2026-02-26T01:24:02+00:00",
      company_uuid: "5522f599-8251-4b01-8859-9421b75a2259",
      company_name: "360 Baby Lasagna",
      blueprint_uuid: "8055a0f6-623c-471a-9eee-4b766beea99c",
      blueprint_name: "Fama 360 v4",
      behavior_kit_uuid: "d6a4eb42-7c10-4736-8afb-d76acccdaeeb",
      behavior_kit_name: "Creative 12 mo",
      workflow_run_uuid: "8832864a-aa2d-4144-82a5-bdb00d7f60a1",
      locked_by: "test@fama.io",
      amendment_opened_at: "2026-02-26T01:24:02+00:00",
    },
  ]);
}
